window.Bernie = window.Bernie || {};
window.Bernie['client-stores'] = window.Bernie['client-stores'] || {};
var mod = require("-!/data/jenkins/workspace/blossom-flex-ui-master/node_modules/happypack/loader.js?id=ts!/data/jenkins/workspace/blossom-flex-ui-master/src/stores/client.ts");
Object.keys(mod).forEach(function (key) { window.Bernie['client-stores'][key] = mod[key]; });
module.exports = window.Bernie['client-stores'];